import { CommonActions, createNavigationContainerRef } from "@react-navigation/native";


export const navigationRef = createNavigationContainerRef();

/**
 *
 * @param {NavigationData} data
 * @param {'tap' | 'foreground'} mode
 */
export function handleNotificationData(data, mode) {

    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
        } catch (e) {
            console.warn("Couldn't parse notification data:", e);
            return;
        }
    }

    switch (data.type){
        case "timer": {
            console.warn("Timer", data)
            navigationRef.navigate('ModalMessage', { screen: 'ShowStep', p1: data.taskid, p2: data.idx});
            break;
        }
        case "contactRequest": {
            if (mode === 'foreground') {
                navigationRef.navigate( 'ModalFcm', { type: 'contactRequest', id: undefined });
            } else {
                navigationRef.dispatch(
                    CommonActions.reset({
                        index: 0,
                        routes: [
                            {
                                name: 'MainStack',
                                state: {
                                    index: 1,
                                    routes: [
                                        { name: 'Home' },
                                        { name: 'ContactManagement' }
                                    ],
                                },
                            },
                        ]
                    })
                );
            }
            break;
        }
        case "newShare":
        case "newCopy": {
            if (mode === 'foreground') {
                navigationRef.navigate( 'ModalFcm', {type: data.type, id: data.workflowId});
            } else {
                navigationRef.dispatch(
                    CommonActions.reset({
                        index: 0,
                        routes: [
                            {
                                name: 'MainStack',
                                state: {
                                    index: 2,
                                    routes: [
                                        { name: 'Home'},
                                        { name: 'Workflows'},
                                        { name: 'ShowWorkflow2', params: {taskid: data.workflowId, isLoading: true}},
                                    ],
                                },
                            },
                        ]
                    })
                );
            }
            break;
        }
        case "plannerEvent":{
            if (mode === 'foreground') {
                navigationRef.navigate('ModalFcm',{ type: data.type, id: data.workflowId});
            } else {
                navigationRef.dispatch(
                    CommonActions.reset({
                        index: 0,
                        routes: [
                            {
                                name: 'MainStack',
                                state: {
                                    index: 2,
                                    routes: [
                                        { name: 'Home' },
                                        { name: 'Planner' },
                                        { name: 'ShowWorkflow', params: { taskid: data.workflowId } },
                                    ],
                                },
                            },
                        ]
                    })
                );
            }
            break;
        }
        case "plannerRequest": {
            if (mode === 'foreground') {
                navigationRef.navigate('ModalFcm', { type: 'plannerRequest' });
            } else {
                navigationRef.dispatch(
                    CommonActions.reset({
                        index: 0,
                        routes: [
                            {
                                name: 'MainStack',
                                state: {
                                    index: 2,
                                    routes: [
                                        { name: 'Home' },
                                        { name: 'Contacts', params: { isPlanner: true, isFinal: false } },
                                        { name: 'PlannerRequests' },
                                    ],
                                },
                            },
                        ],
                    })
                );
            }
            break;
        }
        default: console.warn("No navigation case fitted type: ", data.type)
    }

}